module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/opt/build/repo/src/intl","languages":["ka","en"],"defaultLanguage":"en","redirect":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Alternative Georgia","short_name":"AltGeorgia","start_url":"/","background_color":"#ffffff","theme_color":"#DC143C","display":"minimal-ui","icon":"static/media/altgeo-small-logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"f6cb09d476d404aa28c02813e643c577"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
